export default "/kiban/_next/static/images/discardBoardMark-f7e3654d8cd69b95d2a821819d983d64.png";